module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Investitionskosten Technik","settings":"Einstellungen","updateParamsPendingMessage":"Parameter werden gespeichert...","saveButtonLabel":"Speichern","cancelButtonLabel":"Abbrechen","returnButton":"Zurück"}}')
  delete Component.options._Ctor
}
